"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_select_1 = require("react-select");
const __1 = require("../..");
exports.Menu = (_a) => {
    var { children } = _a, menuProps = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(react_select_1.components.Menu, Object.assign({}, menuProps, { className: __1.classnames(menuProps.className, 'osmosys-select-box-menu') }), children));
};
//# sourceMappingURL=Menu.js.map